import { SubscriptionPlanListResponseSchema, SubscriptionResponseSchema, SubscriptionSchema, InitializeCheckoutResponseSchema, } from '@packages/types';
import { z } from 'zod';
import { api } from '../client.js';
export function listSubscriptionPlans(accountId) {
    return api(`/accounts/${accountId}/subscription-plans`, SubscriptionPlanListResponseSchema);
}
export function getSubscription(accountId, options) {
    const params = new URLSearchParams();
    if (options?.paystackReference)
        params.set('paystackReference', options.paystackReference);
    const qs = params.toString();
    const path = `/accounts/${accountId}/subscription${qs ? `?${qs}` : ''}`;
    return api(path, SubscriptionResponseSchema);
}
export function initializeCheckout(accountId, input) {
    return api(`/accounts/${accountId}/subscription/checkout`, InitializeCheckoutResponseSchema, {
        method: 'POST',
        body: input,
    });
}
export function cancelSubscription(accountId) {
    return api(`/accounts/${accountId}/subscription`, SubscriptionSchema, {
        method: 'DELETE',
    });
}
export function reactivateSubscription(accountId) {
    return api(`/accounts/${accountId}/subscription/reactivate`, SubscriptionSchema, {
        method: 'POST',
    });
}
const RetryPaymentResponseSchema = z.object({});
export function retrySubscriptionPayment(accountId, input) {
    return api(`/accounts/${accountId}/subscription/retry-payment`, RetryPaymentResponseSchema, {
        method: 'POST',
        body: input,
    });
}
